export const color = {
  darkBlue: "#192a56",
};
